module.exports = __webpack_public_path__ + "img/sport_MLB.e2218036.png";